import React from "react";
import "./AboutA.css";

export default function About() {
  return (
    <section className="abouta-sectiona">
      <div className="abouta-wrappera">
        {/* White Rounded Container with Custom Border */}
        <div className="abouta-boxa">
         
          {/* About Content */}
          <div className="abouta-contenta">
            <h3>About Us</h3>
            <h4>The Glamur Family Legacy</h4>
            <p>
              Glamur Paints isn't just a business - it's a family tradition
              passed down through generations. Our grandfather's commitment to
              quality and customer satisfaction laid the foundation for what
              would become a leading name among paint brands in Pakistan. Today,
              we continue his legacy by maintaining the highest standards in
              paint manufacturing while embracing modern technology and
              innovation.
            </p>
            <h4>Our Journey Through Pakistan's Paint Industry</h4>
            <p>
              Over the past four decades, we've witnessed and contributed to the
              transformation of Pakistan's paint industry. From our humble
              beginnings in 1984 to becoming one of the best wall paints
              manufacturers in Pakistan, our journey has been marked by
              continuous innovation, unwavering quality standards, and deep
              customer relationships.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
